import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient, HttpClientXsrfModule, HttpInterceptor } from '@angular/common/http';
import { RootComponent } from './root/root.component';
import { TextblockComponent } from './textblock/textblock.component';
import { TitleblockComponent } from './titleblock/titleblock.component';
import { NavigationComponent } from './navigation/navigation.component';
import { DelimiterComponent } from './delimiter/delimiter.component';
import { TextwithimageblockComponent } from './textwithimageblock/textwithimageblock.component';
import { PersontableComponent } from './persontable/persontable.component';
import { TabsComponent } from './tabs/tabs.component';
import { FormsModule } from '@angular/forms';
import { GooglemapComponent } from './googlemap/googlemap.component';
import { ImageblockComponent } from './imageblock/imageblock.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { PhotogalleryComponent } from './photogallery/photogallery.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker'; 
import { MatNativeDateModule } from '@angular/material/core'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatInputModule } from '@angular/material/input'; 
import { MAT_DATE_LOCALE } from '@angular/material/core'; 
import { MatSelect } from '@angular/material/select'; 
import { MatSelectModule } from '@angular/material/select'; 
import { MatCheckboxModule } from '@angular/material/checkbox'; 
import { MAT_DATE_FORMATS } from '@angular/material/core'; 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbPaginationModule, NgbAlertModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { OwlModule } from 'ngx-owl-carousel';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDirectiveDirective } from './drag-directive.directive';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { QuestionaryComponent } from './questionary/questionary.component';
import { AngularFullpageModule } from '@fullpage/angular-fullpage';
import { MatSliderModule } from '@angular/material/slider';
import { QuestionarySaveComponent } from './questionary-save/questionary-save.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { QuestionaryBadgeComponent } from './questionary-badge/questionary-badge.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { QuestionaryExitintentComponent } from './questionary-exitintent/questionary-exitintent.component';

//slo date adapter
export class SLODateProvider extends NativeDateAdapter {
    parse(value: any) {
        let it = value.split('.');

        if (it.length == 3) {
           return new Date(+it[2], +it[1] - 1, +it[0]);
        }
    }
    format(date: Date, displayFormat: Object) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear();
    }
}




@NgModule({
    declarations: [
        RootComponent, TextblockComponent, TitleblockComponent, NavigationComponent, DelimiterComponent, 
        TextwithimageblockComponent, PersontableComponent, TabsComponent,  GooglemapComponent, ImageblockComponent,
        PhotogalleryComponent, SafeHtmlPipe, DragDirectiveDirective, QuestionaryComponent, QuestionarySaveComponent,
        QuestionaryBadgeComponent,
        QuestionaryExitintentComponent
    ],
    imports: [
        BrowserModule, HttpClientModule, FormsModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, BrowserAnimationsModule, MatSelectModule, MatCheckboxModule,
        NgbPaginationModule, NgbAlertModule, NgbDatepickerModule, OwlModule, ReactiveFormsModule, MatDialogModule, MatAutocompleteModule, MatProgressSpinnerModule,
        HttpClientXsrfModule, NgxMaterialTimepickerModule.setLocale('sl-SI'), MatSliderModule, 
        AngularFullpageModule, ClipboardModule, MatSnackBarModule
    ],
    providers: [
        //{ provide: MAT_DATE_LOCALE, useValue: 'sl' },
        { provide: DateAdapter, useClass: SLODateProvider, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] }
    ],

    bootstrap: [
        RootComponent
    ],
    entryComponents: [
        RootComponent,
        MatDialogModule,
        QuestionarySaveComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDialogModule, MatAutocompleteModule]
})
export class AppModule {

}









